/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drag_The_Pin_To_The_Exact_LocInputs */

const en_drag_the_pin_to_the_exact_loc = /** @type {(inputs: Drag_The_Pin_To_The_Exact_LocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag the pin to the exact location of your asset.`)
};

const id_drag_the_pin_to_the_exact_loc = /** @type {(inputs: Drag_The_Pin_To_The_Exact_LocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seret pin ke lokasi tepat dari aset Anda.`)
};

/** @type {(inputs: Drag_The_Pin_To_The_Exact_LocInputs) => LocalizedString} */
const es_drag_the_pin_to_the_exact_loc = en_drag_the_pin_to_the_exact_loc;

/** @type {(inputs: Drag_The_Pin_To_The_Exact_LocInputs) => LocalizedString} */
const fr_drag_the_pin_to_the_exact_loc = en_drag_the_pin_to_the_exact_loc;

/** @type {(inputs: Drag_The_Pin_To_The_Exact_LocInputs) => LocalizedString} */
const de_drag_the_pin_to_the_exact_loc = en_drag_the_pin_to_the_exact_loc;

/** @type {(inputs: Drag_The_Pin_To_The_Exact_LocInputs) => LocalizedString} */
const ja_drag_the_pin_to_the_exact_loc = en_drag_the_pin_to_the_exact_loc;

/** @type {(inputs: Drag_The_Pin_To_The_Exact_LocInputs) => LocalizedString} */
const zh_drag_the_pin_to_the_exact_loc = en_drag_the_pin_to_the_exact_loc;

/** @type {(inputs: Drag_The_Pin_To_The_Exact_LocInputs) => LocalizedString} */
const ar_drag_the_pin_to_the_exact_loc = en_drag_the_pin_to_the_exact_loc;

/** @type {(inputs: Drag_The_Pin_To_The_Exact_LocInputs) => LocalizedString} */
const it_drag_the_pin_to_the_exact_loc = en_drag_the_pin_to_the_exact_loc;

/** @type {(inputs: Drag_The_Pin_To_The_Exact_LocInputs) => LocalizedString} */
const ru_drag_the_pin_to_the_exact_loc = en_drag_the_pin_to_the_exact_loc;

/** @type {(inputs: Drag_The_Pin_To_The_Exact_LocInputs) => LocalizedString} */
const pt_drag_the_pin_to_the_exact_loc = en_drag_the_pin_to_the_exact_loc;

/** @type {(inputs: Drag_The_Pin_To_The_Exact_LocInputs) => LocalizedString} */
const ko_drag_the_pin_to_the_exact_loc = en_drag_the_pin_to_the_exact_loc;

/**
* | output |
* | --- |
* | "Drag the pin to the exact location of your asset." |
*
* @param {Drag_The_Pin_To_The_Exact_LocInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const drag_the_pin_to_the_exact_loc = /** @type {((inputs?: Drag_The_Pin_To_The_Exact_LocInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drag_The_Pin_To_The_Exact_LocInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_drag_the_pin_to_the_exact_loc(inputs)
	if (locale === "es") return es_drag_the_pin_to_the_exact_loc(inputs)
	if (locale === "fr") return fr_drag_the_pin_to_the_exact_loc(inputs)
	if (locale === "de") return de_drag_the_pin_to_the_exact_loc(inputs)
	if (locale === "ja") return ja_drag_the_pin_to_the_exact_loc(inputs)
	if (locale === "zh") return zh_drag_the_pin_to_the_exact_loc(inputs)
	if (locale === "ar") return ar_drag_the_pin_to_the_exact_loc(inputs)
	if (locale === "id") return id_drag_the_pin_to_the_exact_loc(inputs)
	if (locale === "it") return it_drag_the_pin_to_the_exact_loc(inputs)
	if (locale === "ru") return ru_drag_the_pin_to_the_exact_loc(inputs)
	if (locale === "pt") return pt_drag_the_pin_to_the_exact_loc(inputs)
	return ko_drag_the_pin_to_the_exact_loc(inputs)
});